module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 8 6.8",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }